'use client';

import { useEffect } from 'react';

import { evaluateShippingSettings } from '@/modules/shipping/api';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function InitShippingSettingsEvaluation() {
  const [_, user] = useCurrentUser();
  const userId = user?.id;

  useEffect(() => {
    if (userId) {
      evaluateShippingSettings().catch(() => undefined);
    }
  }, [userId]);

  return null;
}
